export const FROM_FIX_ALL_WRONG_PHOTOS = 'fromFixAllWrongPhotos';
export const HAS_REACHED_FINAL_STEP = 'hasReachedFinalStep';
export const AI_TEXTS = 'aiTexts';
export const HAS_AI_AVAILABLE = 'hasAIAvailable';